module.exports = __webpack_public_path__ + "static/media/tp10.5a5a8be4.JPG";